<div class="legal-container">
    <div class="legal-content">
        <h1 class="title">{{ 'GOOD_PRACTICES.TITLE' | translate }}</h1>
        <hr class="separator-line">
        <p class="subtitle">{{ 'GOOD_PRACTICES.SUBTITLE' | translate }}</p>

        <div class="pdf-grid">
            @for (pdf of pdfs; track pdf.file) {
                <a [href]="pdf.file" target="_blank" rel="noopener" class="pdf-card">
                    <div class="pdf-thumb">
                        <img [src]="pdf.thumb" [alt]="pdf.lang">
                    </div>
                    <p class="pdf-title">
                        <span>{{ pdf.lang }}</span>
                    </p>
                </a>
            }
        </div>
    </div>
</div>
